import { Outlet, Navigate } from "react-router-dom";
import useAuthStore from "../store/authStore";

const CommonRouteProtect = () => {
  const { refToken, isAuthenticated, userType } = useAuthStore();

  return refToken &&
    isAuthenticated &&
    (userType === "admin" || userType === "manager") ? (
    <Outlet />
  ) : (
    <Navigate to={"/login"} />
  );
};
export default CommonRouteProtect;
